import { Information } from 'ustaxes/core/data'

export interface SectionCompletion {
  title: string
  complete: boolean
}

export const getSectionCompletions = (
  info: Information
): SectionCompletion[] => {
  const person = info.taxPayer.primaryPerson
  const hasPersonalInfo =
    person !== undefined &&
    person.firstName !== '' &&
    person.ssid !== '' &&
    info.taxPayer.filingStatus !== undefined

  const hasAddress =
    person !== undefined && person.address.address !== ''

  const personalComplete = hasPersonalInfo && hasAddress

  const hasIncome =
    info.w2s.length > 0 ||
    info.f1099s.length > 0 ||
    info.realEstate.length > 0 ||
    info.f3921s.length > 0

  const paymentsComplete = personalComplete
  const deductionsComplete = personalComplete
  const savingsComplete = personalComplete

  const resultsComplete = personalComplete && hasIncome

  return [
    { title: 'Personal', complete: personalComplete },
    { title: 'Income', complete: hasIncome },
    { title: 'Payments', complete: paymentsComplete },
    { title: 'Deductions', complete: deductionsComplete },
    { title: 'Savings Accounts', complete: savingsComplete },
    { title: 'Results', complete: resultsComplete }
  ]
}
